import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "dropdown"]
  static values = { users: Array }

  connect() {
    this.selectedIndex = -1
    this.mentionStart = null
    this.boundCloseOnClickOutside = (event) => {
      if (!this.element.contains(event.target)) this.closeDropdown()
    }
    document.addEventListener("click", this.boundCloseOnClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.boundCloseOnClickOutside)
  }

  onInput() {
    const textarea = this.inputTarget
    const text = textarea.value.substring(0, textarea.selectionStart)
    const match = text.match(/(^|\s)@(\S*)$/)

    if (match) {
      this.mentionStart = textarea.selectionStart - match[2].length - 1
      this.filterUsers(match[2])
    } else {
      this.closeDropdown()
    }
  }

  onKeydown(event) {
    if (!this.isOpen()) return

    switch (event.key) {
      case "Escape":
        event.preventDefault()
        this.closeDropdown()
        break
      case "ArrowDown":
        event.preventDefault()
        this.moveSelection(1)
        break
      case "ArrowUp":
        event.preventDefault()
        this.moveSelection(-1)
        break
      case "Enter":
        if (this.selectedIndex >= 0) {
          event.preventDefault()
          this.selectCurrent()
        }
        break
    }
  }

  selectUser(event) {
    event.stopPropagation()
    this.insertMention(event.currentTarget.dataset.username)
  }

  filterUsers(query) {
    const matches = this.usersValue.filter(u =>
      u.username.toLowerCase().includes(query.toLowerCase())
    )

    if (matches.length === 0) {
      this.closeDropdown()
      return
    }

    this.selectedIndex = 0
    this.renderDropdown(matches)
  }

  renderDropdown(users) {
    const dropdown = this.dropdownTarget
    dropdown.innerHTML = users.map((u, i) =>
      `<li data-action="click->mention-autocomplete#selectUser"
           data-username="${u.username}"
           class="px-3 py-1.5 text-sm cursor-pointer hover:bg-neutral-100 ${i === 0 ? "bg-neutral-100" : ""}">
        ${u.name} <span class="text-neutral-400">@${u.username}</span>
      </li>`
    ).join("")
    dropdown.classList.remove("hidden")
  }

  insertMention(username) {
    const textarea = this.inputTarget
    const before = textarea.value.substring(0, this.mentionStart)
    const after = textarea.value.substring(textarea.selectionStart)
    textarea.value = before + `@${username} ` + after
    const newPos = this.mentionStart + username.length + 2
    textarea.setSelectionRange(newPos, newPos)
    this.closeDropdown()
    textarea.focus()
  }

  selectCurrent() {
    const items = this.dropdownTarget.querySelectorAll("li")
    if (items[this.selectedIndex]) {
      this.insertMention(items[this.selectedIndex].dataset.username)
    }
  }

  moveSelection(direction) {
    const items = this.dropdownTarget.querySelectorAll("li")
    if (items.length === 0) return

    items[this.selectedIndex]?.classList.remove("bg-neutral-100")
    this.selectedIndex = (this.selectedIndex + direction + items.length) % items.length
    items[this.selectedIndex]?.classList.add("bg-neutral-100")
  }

  closeDropdown() {
    this.dropdownTarget.classList.add("hidden")
    this.dropdownTarget.innerHTML = ""
    this.selectedIndex = -1
    this.mentionStart = null
  }

  isOpen() {
    return !this.dropdownTarget.classList.contains("hidden")
  }
}
